import ioniconaaddoutline from "../../assets/dashboard/ioniconaaddoutline.svg";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import InputsNew from "../common/InputsNew";
import { ApolloError, useMutation, useQuery } from "@apollo/client";
import { GET_ALL_SKILLS } from "../../api/query";
import Loader from "../common/Loader";
import closeDowpDowniconimg from "../../assets/task/closedropdown-cicon.svg";
// import { CREATE_SKILLS, DELETE_SKILLS } from "../../api/mutation";
import { showError, showSuccess } from "../common/ToastNotification";
import { useState } from "react";
import NotifyPopup from "../dashboard/NotifyPopup";
import { CREATE_SKILLS, DELETE_SKILLS } from "../../api/mutation";

interface AddSkill {
    skill: string;
    description: string
}

// Validation schema
const addSkillSchema = yup.object().shape({
    skill: yup.string()
        .test('not-only-whitespace', 'Please add a valid Skill', value => !value || value.trim().length > 0)
        .required('This field is required'),
    description: yup.string()
        .test('not-only-whitespace', 'Please add a valid Description', value => !value || value.trim().length > 0)
        .required('This field is required'),
});

const AddSkill = () => {
    const [isDeletePopup, setIsDeletePopup] = useState(false);
    const [deleteSkillId, setDeleteSkillId] = useState('')

    //api
    const { data, loading, refetch } = useQuery(GET_ALL_SKILLS, {
        fetchPolicy: 'no-cache',
    });

    const [createSkill, { loading: createSkillLoading }] = useMutation(CREATE_SKILLS, {
        fetchPolicy: 'no-cache',
    })

    const [deleteSkill, { loading: deleteSkillLoading }] = useMutation(DELETE_SKILLS, {
        fetchPolicy: 'no-cache',
    })

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm<AddSkill>({
        resolver: yupResolver(addSkillSchema)
    });

    const skills = data?.get_all_skills?.skills

    async function handleRemoveSkill() {
        const id = parseInt(deleteSkillId)

        try {
            const response = await deleteSkill({
                variables: {
                    skill_ids: [id]
                }
            });
            if (response.data.delete_skills.status_code === 200) {
                showSuccess(response.data.delete_skills.message)
                refetch()
                setDeleteSkillId('')
                setIsDeletePopup(false)
            }
            if (response.data.delete_skills.status_code === 400) {
                showError(response.data.delete_skills.message)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    async function onSubmit(data: AddSkill) {
        const skillInput = {
            skill_name: data?.skill,
            description: data?.description
        }

        try {
            const response = await createSkill({
                variables: {
                    skills_input: skillInput
                }
            });
            if (response.data.create_skills.status_code === 201) {
                showSuccess(response.data.create_skills.message)
                refetch()
                reset()
            }
            if (response.data.create_skills.status_code === 400) {
                showError(response.data.create_skills.message)
            }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="w-full  grid ">
                <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 mt-[8px] gap-[8px] min-w-full">

                    <InputsNew
                        contentPlaceholder="Skill"
                        type="text"
                        register={register('skill')}
                        errorMessage={errors.skill}
                    />
                    <InputsNew
                        contentPlaceholder="Description"
                        type="text"
                        register={register('description')}
                        errorMessage={errors.description}
                    />
                    <div className="flex items-end relative">
                        <button
                            type="submit"
                            className="cursor-pointer agency-btn flex flex-col absolute top-[8px] items-center justify-start p-[10px] plus-task-btn taskdash-plush-img rounded"
                        >
                            <img
                                className="w-4 h-4 relative overflow-hidden shrink-0 top-[2px]"
                                loading="lazy"
                                alt=""
                                src={ioniconaaddoutline}
                            />
                        </button>
                    </div>

                </div>




                {/* List */}
                <div className=" mt-[24px] grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1 gap-[8px] min-w-full">
                    {skills?.map((s: any) => {
                        return (
                            <div
                                key={s.id}
                                className="flex justify-between items-center border rounded px-3 py-2 bg-gray-50 items-dark-blg"
                            >
                                <span>
                                    <strong>{s?.skill_name}</strong> - {s?.description}
                                </span>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setIsDeletePopup(true)
                                        setDeleteSkillId(s?.id)
                                    }}
                                    className="cursor-pointer agenda-nner_btn"
                                >
                                    <span><img src={closeDowpDowniconimg} className="w-4 h-4" alt="" /></span>
                                </button>
                            </div>
                        )
                    })}
                </div>
            </form>
            {isDeletePopup && (
                <NotifyPopup
                    onsubmit={handleRemoveSkill}
                    back={() => {
                        setIsDeletePopup(false);
                    }}
                    isDelete={true}
                    showMessage={"Are you sure you want to delete this Skill?"}
                />
            )}
            {(loading || createSkillLoading || deleteSkillLoading) && (
                <Loader />
            )}
        </>
    );
}

export default AddSkill;